import { useStorage } from '@vueuse/core';

export function useLocale() {
  const currentLocale = useStorage('locale', 'en');

  const setLocale = lang => {
    currentLocale.value = lang;
  };

  return { currentLocale, setLocale };
}
